import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type Document, type AIExtraction } from '../../api/documents';

export function AIExtractionViewerPage() {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [extractions, setExtractions] = useState<Record<string, AIExtraction>>({});
  const [error, setError] = useState('');

  useEffect(() => {
    void documentsApi.listDocuments(50).then((r) => setDocuments(r.documents)).catch((e) => setError(String(e)));
  }, []);

  const extract = async (doc: Document) => {
    try {
      const ext = await documentsApi.runExtraction(doc.id);
      setExtractions((prev) => ({ ...prev, [doc.id]: ext }));
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/documents" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Document Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">AI Extraction Viewer</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-4">
        {documents.map((d) => (
          <li key={d.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{d.name}</span>
              <button onClick={() => void extract(d)} className="text-sm text-blue-600 hover:underline">Extract</button>
            </div>
            {extractions[d.id] && (
              <div className="mt-3 text-sm">
                <p>Type: {extractions[d.id].extraction_type}</p>
                <p className="mt-1">{extractions[d.id].summary}</p>
                {extractions[d.id].tags && (
                  <div className="mt-2 flex flex-wrap gap-1">
                    {extractions[d.id].tags!.map((t) => (
                      <span key={t} className="rounded bg-slate-100 px-2 py-0.5 text-xs dark:bg-slate-800">{t}</span>
                    ))}
                  </div>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
